module.exports = __webpack_public_path__ + "img/introductie_02_energie.d57bc271.png";